import React from 'react';
import { Route, Routes, BrowserRouter} from 'react-router-dom';
import RequireAuth from './contexts/RequireAuth';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import DailyExpense from './pages/DailyExpense';
import MaterialsExpense from './pages/MaterialsExpense';
import LaborExpense from './pages/LaborExpense';
import OtherExpenses from './pages/OtherExpenses';
import Home from './pages/Home';
import Settings from './pages/Settings';
import Sales from './pages/Sales';
import ResetPassword from './pages/ResetPassword'
import { UnitShadeProvider } from "./contexts/UnitShadeContext";

function App() {
  return (
    <UnitShadeProvider>
    <div>
        <BrowserRouter>
          <Routes>
              {/* Public Routes */}
              <Route path='/login' element={<Login />}  />
              <Route path = '/forgot-password' element={<ForgotPassword />} />
              <Route path = '/reset-password' element={<ResetPassword />} />
              {/* Protected Routes */}
              <Route element={<RequireAuth />}>
                  <Route path = '' element={<Home />} />
                  <Route path = '/sales' element={<Sales />} />
                  <Route path = '/daily-expense' element={<DailyExpense />} />
                  <Route path = '/materials-expense' element={<MaterialsExpense />} />
                  <Route path = '/labor-expense' element={<LaborExpense />} />
                  <Route path = '/other-expenses' element={<OtherExpenses />} />
                  <Route path = '/settings' element={<Settings />} />
              </Route>
          </Routes>
        </BrowserRouter>
    </div>
    </UnitShadeProvider>
  );
}

export default App;
